<template>
  <div class="password">
    <van-form @submit="onSubmit" class="line-form">
      <van-field v-model="password" class="disabled"
        label="原始密码" placeholder="请输入原始密码"
        type="password"
        :rules="[{ required: true, message: '请填写原始密码' }]"
      />
      <van-field v-model="password1"
        type="password" label="新密码" placeholder="请输入新密码"
        :rules="[{ required: true, message: '请填写新密码' }]"
      />
      <van-field v-model="password2"
        type="password" label="确认密码" placeholder="请再次输入密码"
        :rules="[{ required: true, message: '请填写确认密码' }]"
      />
      <van-field v-model="verifyCode"
        label="获取验证码" placeholder="请输入获取验证码" clearable center
        :rules="[{ required: true, message: '请填写验证码' }]"
      >
        <template #button>
          <van-button plain type="info" native-type="button" size="small" class="code-btn" @click.stop="getSMSCode">
            {{ numCount == 60 ? '获取验证码' : `${numCount}s` }}
          </van-button>
        </template>
      </van-field>
      <div class="btn-group">
        <van-button class="btn-save" block type="info" native-type="submit">保存</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import api from '@/utils/api/personCenter'
import MD5 from 'md5.js'
import commonApi from '@/utils/api/common.js'
import moduleMixins from '@/mixins/moduleMixins'

export default {
  components: {},
  mixins: [ moduleMixins ],
  props: {},
  data() {
    return {
      password: '',
      password1: '',
      password2: '',
      verifyCode:'',// 验证码
      numCount:60,// 倒计时60s
      userInfo:{}
    };
  },
  watch: {},
  computed: {
    navTitle() {
      return '修改密码'
    }
  },
  methods: {
    onSubmit() {
      let params = {}
      const md5Password = new MD5().update(this.password).digest('hex')
      const newMd5Password = new MD5().update(this.password1).digest('hex')
      const validMd5Password = new MD5().update(this.password2).digest('hex')

      if(this.password1 !== this.password2){
        this.$toast('两次密码不一致')
        return
      }

      params.oldPassword = md5Password
      params.newPassword = newMd5Password
      params.validate = this.verifyCode
      api
        .updatePassword(params)
        .then(res => {
          console.log(res)
          if(res.code == 0){
            this.$toast('修改密码成功');
            this.$bus.$emit('refreshUserInfo')
            setTimeout(()=>{
              // this.$router.go(-1)
              this.confirmLogin()
            },2000)
          }
 
        })
        .catch(err => {
          this.$toast(err.response.data.message)
          console.log(err)
        })
    },
    // 获取短信验证码
    getSMSCode() {
      if(this.numCount != 60 ) {
        this.$toast('不允许频繁请求')
        return
      }
      if(!this.userInfo.mobilePhone) {
        this.$toast('请输入手机号')
        return
      }
      api.sendVerification({
        mobileNo: this.userInfo.mobilePhone
      }).then(() => {
        this.$toast('短信发送成功')
        let timer = setInterval(()=> {
          this.numCount--
          if(this.numCount <= 0) {
            clearInterval(timer)
            this.numCount = 60
          }
        }, 1000)
      })
    },
    confirmLogin(){
      this.$dialog.confirm({
        title: '—— 温馨提示 ——',
        message: '修改密码后需要重新登录账号，是否确认登录？',
        confirmButtonText: '去登录',
        confirmButtonColor: '#1D84FF'
      })
      .then(() => {
        this.$router.go(-1)
        this.login()
      }).catch(() => {
        // on cancel
        // this.logOut()
      });
    },
    login(){
      if (this.$store.state.loginConfig.isHaveThirdLogin == '1') {
        //第三方登录，统一身份登录一定要小程序
        if (window.__wxjs_environment === 'miniprogram') {
          wx.miniProgram.navigateTo({
            url: '/pages/faceWebview/faceWebview?currentUserType=1'
          })
        } else {
          this.$toast('请使用小程序登录')
        }
      } else {
        if (window.__wxjs_environment === 'miniprogram') {
          wx.miniProgram.navigateTo({
            url: '/pages/webPage/webPage?webUrl=login?title=登录'
          })
        } else {
          this.$router.push({
            name: 'Login'
          })
        }
      }
    },
    loadData(){// 获取主数据
      let params = {}
      // 
      
    },
  },
  created() {},
  mounted() {
    this.userInfo = this.$store.state.userInfo ? this.$store.state.userInfo : '';
  }
};
</script>
<style lang="scss" scoped>
.password {
  height: 100vh;
  background-color: #fff;
  .line-form {
    padding: 15px;
    background-color: #fff;
    ::v-deep .van-cell {
      display: block;
      .van-field__label {
        width: 100%;
        padding-bottom: 5px;
      }
      .van-field__value .van-field__body {
        padding: 5px 10px;
        border: 1px solid #ddd;
      }
      &::after {
        border-bottom: 0;
      }
    }
    .btn-group {
      margin: 50px 20px;
      .btn-save{
        background: #1D84FF;
        border-radius: 5px;
      }
    }
  }
}
</style>